export default __webpack_public_path__ + "static/media/CimmerianSettlementMap.d3321e85.jpg";